

import { Button, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SimpleModal from 'views/MapView/components/SimpleModal';

/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */

/**
 * Estilização do componente ModalBody
 */
export const ModalBody = styled.div`
  padding-top: 32px;
  p {
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    color: #5e6366;
  }

  .MuiButton-root {
    background: #3c71dd;
    border-radius: 3px;
    width: 185.14px;
    height: 40px;
  }

  .MuiButton-label {
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #ffffff;
    text-transform: none;
  }
`;

export const CustomModalSaveAsLayer = ({
  title,
  saveModalOpen,
  handleCloseSaveModal,
  formik,
  SliderColorPicker
}) => {
  return (
    <SimpleModal
      title={title}
      activeWithBgColor
      open={saveModalOpen}
      onClose={handleCloseSaveModal}
    >
      <ModalBody>
        <TextField
          id="layer-name"
          name="layerName"
          label="Nome da camada"
          variant="outlined"
          size="small"
          fullWidth
          inputProps={{ maxLength: 70 }}
          error={formik.touched.layerName && formik.errors.layerName}
          helperText={formik.touched.layerName && formik.errors.layerName}
          {...formik.getFieldProps('layerName')}
        />

        {SliderColorPicker}

        <p style={{ marginLeft: 9 }}>
          Após salvar o desenho não será permitido editá-lo.
        </p>
        <div style={{ margin: '32px auto 0', width: '185.14px' }}>
          <Button
            variant="contained"
            color="primary"
            component="div"
            onClick={formik.handleSubmit}
          >
            Salvar
          </Button>
        </div>
      </ModalBody>
    </SimpleModal>
  );
};

CustomModalSaveAsLayer.propTypes = {
  title: PropTypes.string.isRequired,
  saveModalOpen: PropTypes.bool.isRequired,
  handleCloseSaveModal: PropTypes.func.isRequired,
  formik: PropTypes.object.isRequired, 
};

CustomModalSaveAsLayer.properties = {
  ignore: true,
};
